import { logError } from './IwDataDogLogger';

export function logErrorMiddleware() {
    return function wrapDispatchToLogErrors(next) {
        return function tryCatchDispatch(action) {
            try {
                return next(action);
            } catch (error) {
                logError(`ACTION: ${action.type}`, {
                    tags: { reporter: 'reducer' },
                    extra: {
                        message: error.message
                    }
                });

                //Throw error again to be caught up
                throw error;
            }
        };
    };
}
